import {
  SERVICES_ADMIN_ADD_FAVOURITE,
  SERVICES_ADMIN_FETCH_ALL_CONTACT_SUCCESS,
  SERVICES_ADMIN_FILTER_CONTACT,
  SERVICES_ADMIN_GET_ALL_CONTACT,
  SERVICES_ADMIN_GET_UNSELECTED_ALL_CONTACT,
  SERVICES_ADMIN_HANDLE_REQUEST_CLOSE,
  SERVICES_ADMIN_HIDE_CONTACT_LOADER,
  SERVICES_ADMIN_ON_ADD_CONTACT,
  SERVICES_ADMIN_ON_ALL_CONTACT_SELECT,
  SERVICES_ADMIN_ON_CONTACT_CLOSE,
  SERVICES_ADMIN_ON_CONTACT_SELECT,
  SERVICES_ADMIN_ON_DELETE_CONTACT,
  SERVICES_ADMIN_ON_DELETE_SELECTED_CONTACT,
  SERVICES_ADMIN_ON_FILTER_OPTION_SELECT,
  SERVICES_ADMIN_ON_SAVE_CONTACT,
  SERVICES_ADMIN_ON_TOGGLE_DRAWER,
  SERVICES_ADMIN_SHOW_MESSAGE,
  SERVICES_ADMIN_UPDATE_SEARCH_USER,
  SERVICES_CATEGORY_ADMIN_UPDATE_SEARCH_USER,
  CHANGE_SERVICES_ADMIN_DISPLAY,
  FILL_ADMIN_SERVICES_SELECTED_DETAILS,
  SUBMIT_EDIT_SERVICES_DETAILS_RESPONSE,
  CHANGE_EDIT_SERVICES_STATE,
  CHANGE_ADD_SERVICES_STATE,
  SERVICES_CLEAR_FORM_DATA,
  SELECTED_SERVICES_DELETE_RESPONSE,
  SET_SERVICES_CATEGORY,
  SET_SERVICES_BUSINESS_CATEGORY,
  SELECT_CATEGORY_ID,
  SELECT_SERVICES_ID,
  SUBMIT_NEW_SERVICES_ADMIN,
  DELETED_SERVICE_RESPONSE,
  SUBMIT_NEW_SERVICES_ADMIN_RESPONSE,
  SERVICES_FAIL_RESPONSE,
  SERVICES_ON_HIDE_LOADER2,
  SERVICES_ON_SHOW_LOADER,
  SERVICES_DELETE_MODAL_TOGGLE,
  HAVE_APPOINTMENT_DELETE_SERVICES,
  APPOINTMENT_DELETE_SERVICES_FORCEFULLY,
  APPOINTMENT_DELETE_SERVICES_FORCEFULLY_RESPONSE,
  ADD_SERVICES_BUSINESS_CATEGORY
} from "constants/ActionTypes";

const INIT_STATE = {
  alertMessage: "",
  showMessage: false,
  errorMessage: false,
  loader: true,
  servicesLoader: false,
  noContentFoundMessage: "No Services found",
  selectedSectionId: 1,
  drawerState: false,
  // user: {
  //   name: "Robert Johnson",
  //   email: "robert.johnson@example.com",
  //   avatar: "http://via.placeholder.com/150x150",
  // },
  searchUser: "",
  filterOption: "All contacts",
  allContact: [],
  contactList: [], // only for prod
  // allContact: data,
  // contactList: data,
  selectedContact: null,
  selectedContacts: 0,
  addContactState: false,
  displayComponent: 1,
  addServicesState: false,
  editServicesState: false,
  categoryArray: [],
  exceptionCategoryArray: [],
  businessCategoryArray: [],
  selectedCategory: "",
  servicesBasedOnCategory: [],
  selectedService: "",
  price: 0,
  duration: "",
  description: "",
  customService: "",
  selectedServiceId: "",
  deleteServicesModal: false,
  appointmentsServices: [],
};

export default (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case SERVICES_ADMIN_FETCH_ALL_CONTACT_SUCCESS: {
      return {
        ...state,
        loader: false,
        allContact: payload,
        contactList: payload,
      };
    }
    case SERVICES_ADMIN_SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: payload,
        showMessage: true,
        loader: false,
      };
    }
    case SERVICES_ADMIN_ON_CONTACT_SELECT: {
      payload.selected = !payload.selected;
      let selectedContacts = 0;
      const contactList = state.contactList.map(contact => {
        if (contact.selected) {
          selectedContacts++;
        }
        if (contact.id === payload.id) {
          if (contact.selected) {
            selectedContacts++;
          }
          return payload;
        }
        return contact;
      });
      return {
        ...state,
        INIT_STATE,
        selectedContacts,
        contactList,
      };
    }

    case SERVICES_ADMIN_ON_DELETE_SELECTED_CONTACT: {
      const contacts = state.allContact.filter(contact => !contact.selected);
      return {
        ...state,
        alertMessage: "Contact Deleted Successfully",
        showMessage: true,
        allContact: contacts,
        contactList: contacts,
        selectedContacts: 0,
      };
    }
    case SERVICES_ADMIN_FILTER_CONTACT: {
      const { filterOption } = state;
      let contactList = [];
      if (payload === "") {
        contactList = state.allContact;
      } else {
        const filterContact = state.allContact.filter(
          contact => contact.name.toLowerCase().indexOf(payload.toLowerCase()) > -1
        );
        if (filterOption === "All contacts") {
          contactList = filterContact;
        } else if (filterOption === "Frequently contacted") {
          contactList = filterContact.filter(contact => contact.frequently);
        } else if (filterOption === "Starred contacts") {
          contactList = filterContact.filter(contact => contact.starred);
        }
      }
      return { ...state, contactList };
    }
    case SERVICES_ADMIN_GET_ALL_CONTACT: {
      const contactList = state.allContact.map(contact =>
        contact
          ? {
            ...contact,
            selected: true,
          }
          : contact
      );
      return {
        ...state,
        selectedContacts: contactList.length,
        allContact: contactList,
        contactList,
      };
    }
    case SERVICES_ADMIN_GET_UNSELECTED_ALL_CONTACT: {
      const contactList = state.allContact.map(contact =>
        contact
          ? {
            ...contact,
            selected: false,
          }
          : contact
      );
      return {
        ...state,
        selectedContacts: 0,
        allContact: contactList,
        contactList,
      };
    }
    case SERVICES_ADMIN_ON_ALL_CONTACT_SELECT: {
      const selectAll = state.selectedContacts < state.contactList.length;
      let selectedContacts = 0;
      let contactList = [];
      if (selectAll) {
        contactList = state.allContact.map(contact =>
          contact
            ? {
              ...contact,
              selected: true,
            }
            : contact
        );
        selectedContacts = contactList.length;
      } else {
        contactList = state.allContact.map(contact =>
          contact
            ? {
              ...contact,
              selected: true,
            }
            : contact
        );
        selectedContacts = 0;
      }
      return {
        ...state,
        selectedContacts,
        allContact: contactList,
        contactList,
      };
    }
    case SERVICES_ADMIN_UPDATE_SEARCH_USER: {
      const { allContact } = state;
      const contactList = allContact.filter(
        item => item.name.toLowerCase().indexOf(payload.trim().toLowerCase()) > -1
      );

      return { ...state, searchUser: payload, contactList };
    }
    case SERVICES_CATEGORY_ADMIN_UPDATE_SEARCH_USER: {
      const { allContact } = state;
      const contactList = allContact.filter(
        item => item.category.name.toLowerCase().indexOf(payload.trim().toLowerCase()) > -1
      );

      return { ...state, contactList };
    }
    case SERVICES_ADMIN_HANDLE_REQUEST_CLOSE: {
      return { ...state, showMessage: false, errorMessage: false };
    }
    case SERVICES_ADMIN_ON_TOGGLE_DRAWER: {
      return { ...state, drawerState: !state.drawerState };
    }
    case SERVICES_ADMIN_HIDE_CONTACT_LOADER: {
      return { ...state, loader: false };
    }

    case CHANGE_SERVICES_ADMIN_DISPLAY:
      return {
        ...state,
        displayComponent: payload,
      };

    case FILL_ADMIN_SERVICES_SELECTED_DETAILS: {
      const { category, price, duration, description, name, _id, custom_service } = payload;
      let exceptionCategoryArray = [];
      const { categoryArray, businessCategoryArray } = state;
      let servicesBasedOnCategory = categoryArray.filter(item => item.name === category.name);

      if (servicesBasedOnCategory.length == 0) {
        exceptionCategoryArray = [...categoryArray];
        servicesBasedOnCategory = businessCategoryArray.filter(item => item.name === category.name);
        exceptionCategoryArray.push(servicesBasedOnCategory[0]);
      }
      const selectedService = custom_service ? "Other" : name;

      return {
        ...state,
        editServicesState: true,
        displayComponent: 2,
        selectedCategory: category.name,
        price,
        duration: Math.floor(duration / 60),
        description,
        customService: name,
        selectedService,
        selectedServiceId: _id,
        servicesBasedOnCategory: servicesBasedOnCategory[0].services,
        exceptionCategoryArray
      };
    }

    case CHANGE_EDIT_SERVICES_STATE:
      return { ...state, editServicesState: payload };

    case CHANGE_ADD_SERVICES_STATE:
      return { ...state, addServicesState: payload };

    case SUBMIT_EDIT_SERVICES_DETAILS_RESPONSE: {
      const { _id } = payload;
      const allContact = state.allContact.filter(item => item._id !== _id);

      return {
        ...state,
        displayComponent: 1,
        alertMessage: "vibo.notification.services.update",
        showMessage: true,
        editServicesState: false,
        addServicesState: false,
        selectedService: "",
        selectedCategory: "",
        price: 0,
        duration: "",
        description: "",
        customService: "",
        selectedServiceId: "",
        servicesLoader: false,
        allContact: [...allContact, payload],
        contactList: [...allContact, payload],
      };
    }

    case SERVICES_CLEAR_FORM_DATA:
      return {
        ...state,
        selectedService: "",
        selectedCategory: "",
        price: 0,
        duration: "",
        description: "",
        customService: "",
      };

    case DELETED_SERVICE_RESPONSE: {
      let { allContact } = state;
      const { deleteServices } = payload;
      deleteServices.forEach(element => {
        allContact = allContact.filter(item => item._id !== element);
      });

      return {
        ...state,
        alertMessage: "vibo.notification.services.delete",
        showMessage: true,
        selectedContacts: 0,
        allContact,
        contactList: allContact,
      };
    }

    case SET_SERVICES_CATEGORY:
      return { ...state, categoryArray: payload };

    case SET_SERVICES_BUSINESS_CATEGORY:
      return { ...state, businessCategoryArray: payload };

    case SELECT_CATEGORY_ID: {
      return {
        ...state,
        selectedCategory: payload.category,
        servicesBasedOnCategory: payload.services,
      };
    }
    case SELECT_SERVICES_ID: {
      return {
        ...state,
        selectedService: payload.selectedService,
        price: payload.price,
        duration: payload.duration,
        description: payload.description,
        customService: payload.customService,
      };
    }
    case SUBMIT_NEW_SERVICES_ADMIN_RESPONSE:
      return {
        ...state,
        alertMessage: "vibo.notification.services.add",
        showMessage: true,
        addServicesState: false,
        editServicesState: false,
        displayComponent: 1,
        selectedService: "",
        selectedCategory: "",
        price: 0,
        duration: "",
        description: "",
        customService: "",
        servicesLoader: false,
        allContact: [...state.allContact, payload],
        contactList: [...state.allContact, payload],
      };

    case SERVICES_FAIL_RESPONSE:
      return { ...state, errorMessage: true, alertMessage: payload };

    case SERVICES_ON_HIDE_LOADER2:
      return { ...state, servicesLoader: false };

    case SERVICES_ON_SHOW_LOADER:
      return { ...state, servicesLoader: true };

    case SERVICES_DELETE_MODAL_TOGGLE:
      return { ...state, deleteServicesModal: !state.deleteServicesModal };

    case HAVE_APPOINTMENT_DELETE_SERVICES: {
      const { dontDeleteServices, deleteServices } = payload;
      let { allContact } = state;
      deleteServices.forEach(element => {
        allContact = allContact.filter(item => item._id !== element);
      });

      return {
        ...state,
        appointmentsServices: dontDeleteServices,
        deleteServicesModal: true,
        allContact,
        contactList: allContact,
      };
    }

    case APPOINTMENT_DELETE_SERVICES_FORCEFULLY_RESPONSE: {
      let { allContact, appointmentsServices } = state;
      appointmentsServices.forEach(element => {
        allContact = allContact.filter(item => item._id !== element);
      });
      return {
        ...state,
        alertMessage: "vibo.notification.services.delete",
        showMessage: true,
        selectedContacts: 0,
        servicesLoader: false,
        deleteServicesModal: false,
        appointmentsServices: [],
        allContact,
        contactList: allContact,
      };
    }
    case ADD_SERVICES_BUSINESS_CATEGORY:
      return { ...state, businessCategoryArray: [ ...state.businessCategoryArray, payload ] }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/ServicesAdminReducer.js